<app-mjml-renderer
    *ngIf="staticPageModel && mjml"
    [mjml]="mjml"
    [showHeaderAndFooter]="true"
    [eventId]="staticPageModel.eventId"
    [fundraiserId]="staticPageModel.fundraiserId"
    [screenshots]="true">
</app-mjml-renderer>
